import { textStyleCss } from 'src/theme/atlas';
import { hexToRgb } from 'src/utils/commonFunctions';
import styled from 'styled-components';

export type TagVariant = 'default' | 'disabled';
export type TagLocation = 'dropdown';

export const TagStyled = styled.div<{
  variant: TagVariant;
  tagLocation?: TagLocation;
  customColor?: string;
  size?: 'medium' | 'small';
  flexToFitSpace?: boolean;
}>`
  ${(props) =>
    textStyleCss(
      props.size === 'small'
        ? props.theme.atlas.typography.semantic.caption
        : props.theme.atlas.typography.semantic.bodySmall,
    )}
  background-color: ${(props) =>
    props.customColor
      ? hexToRgb(props.customColor, 0.15)
      : props.theme.atlas.semantic.color.surface.variant};
  border: ${(props) =>
    props.customColor ? `1px solid ${props.customColor}` : 'none'};
  padding: 4px 8px;
  display: flex;
  align-items: center;
  border-radius: 3px;
  ${(props) =>
    props.flexToFitSpace
      ? `
    max-width: fit-content;
    min-width: 0;
    flex: 1;
    `
      : `width: fit-content;`}
  ${(props) => {
    if (props['aria-readonly']) {
      return `
          color: ${
            props.customColor
              ? props.theme.atlas.semantic.color.type.default
              : props.theme.atlas.semantic.color.type.disabled
          };
          i {
            cursor: not-allowed;
          }
        `;
    }
    switch (props.variant) {
      case 'default':
        return `
          color: ${props.theme.atlas.semantic.color.type.default};
          i {
            cursor: pointer;
          }
          @media (hover: hover) {
            &:hover {
              background-color: ${
                props.customColor
                  ? hexToRgb(props.customColor, 0.3)
                  : props.theme.atlas.semantic.color.action.secondary.activeFill
              };
            }
          }
        `;
      case 'disabled':
        return `
          color: ${props.theme.atlas.semantic.color.type.disabled};
          i {
            cursor: not-allowed;
          }
        `;
    }
  }};
`;

export const TagTextStyled = styled.p<{ noWrap?: boolean }>`
  margin: 0;
  cursor: default;
  ${(props) =>
    props.noWrap &&
    `white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    `}
`;
